module.exports = __webpack_public_path__ + "static/media/OpenSans SemiBold-01.7652abd7.svg";